import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdvertisersComponent } from './advertisers/advertisers.component';
import { AdvertisersDetailComponent } from './advertisers-detail/advertisers-detail.component';
import { EditAdvertiserModalComponent } from './edit-advertiser-modal/edit-advertiser-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    AdvertisersComponent,
    AdvertisersDetailComponent,
    EditAdvertiserModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgbModule,
    //NgbActiveModal
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [EditAdvertiserModalComponent]
})
export class AppModule { }
